module.exports = __webpack_public_path__ + "img/hr-H-B-2-load-standup-shadow.2593b7a8.png";